import Dashboard from "../components/admin/Dashboard";
import Profile from "../components/admin/Profile";
import AddCategory from "../components/admin/category/AddCategory";
import ViewCategory from "../components/admin/category/ViewCategory";
import EditCategory from "../components/admin/category/EditCategory";
import AddProduct from "../components/admin/product/AddProduct";
import ViewProduct from "../components/admin/product/ViewProduct";
import ShopifyStoreCloner from "../components/admin/Shopify/ShopifyStoreCloner";
import WooCommerceStoreCloner from "../components/admin/WooCommerce/WooCommerceStoreCloner";
import EditProduct from "../components/admin/product/EditProduct";
import OrderView from "../components/admin/Orders/OrderView";
import AdminOrderDetails from "../components/admin/Orders/AdminOrderDetails";
import AdminInventory from "../components/admin/Inventory/AdminInventory";
import AdminCustomers from "../components/admin/Customers/AdminCustomers";
import AdminCoupons from "../components/admin/Coupons/AdminCoupons";
import AdminReviews from "../components/admin/Reviews/AdminReviews";
import AdminReports from "../components/admin/Reports/AdminReports";
import { Redirect } from "react-router-dom";
import AdminSettings from "../components/admin/Settings/AdminSettings";
import UserView from "../components/admin/Users/UserView";
import DiscountView from "../components/admin/Discount/DiscountView";
import InvoiceView from "../components/admin/Invoice/InvoiceView";
import InvoiceDetails from "../components/admin/Invoice/InvoiceDetails";
import MoneyOverview from "../components/admin/Money/MoneyOverview";
import CourierSettings from "../components/admin/Couriers/CourierSettings";
import PaymentSettings from "../components/admin/Payments/PaymentSettings";
import PolicySettings from "../components/admin/Policies/PolicySettings";
import Ledger from "../components/admin/Ledger/Ledger";
import RefundViewMain from "../components/admin/Refund/RefundViewMain";
import SaleOrderView from "../components/admin/Refund/SaleOrderView";
import SaleOrderDetailsView from "../components/admin/Refund/SaleOrderDetailsView";
import RefundOrderDetailsView from "../components/admin/Refund/RefundOrderDetailsView";
import ThemeEditor from "../components/admin/Themes/ThemeEditor";
import ThemeLibrary from "../components/admin/Themes/ThemeLibrary";
import SeoAudit from "../components/admin/Seo/SeoAudit";
import SearchConsole from "../components/admin/Seo/SearchConsole";
import StoreBackup from "../components/admin/Backup/StoreBackup";
import AdminBundles from "../components/admin/Bundles/AdminBundles";

const routes = [
  { path: "/admin", exact: true, name: "Admin" },
  { path: "/admin/dashboard", exact: true, name: "Dashboard", component: Dashboard },

  // Catalog & Products
  { path: "/admin/products", exact: true, name: "Products", component: ViewProduct },
  { path: "/admin/bundles", exact: true, name: "Bundles", component: AdminBundles },
  { path: "/admin/view-product", exact: true, name: "ViewProduct", component: ViewProduct },
  { path: "/admin/shopify-import", exact: true, name: "ShopifyStoreCloner", component: ShopifyStoreCloner },
  { path: "/admin/woocommerce-import", exact: true, name: "WooCommerceStoreCloner", component: WooCommerceStoreCloner },
  { path: "/admin/add-product", exact: true, name: "AddProduct", component: AddProduct },
  { path: "/admin/edit-product/:id", exact: true, name: "EditProduct", component: EditProduct },

  // Categories
  { path: "/admin/categories", exact: true, name: "Categories", component: ViewCategory },
  { path: "/admin/view-category", exact: true, name: "ViewCategory", component: ViewCategory },
  { path: "/admin/add-category", exact: true, name: "AddCategory", component: AddCategory },
  { path: "/admin/edit-category/:id", exact: true, name: "EditCategory", component: EditCategory },

  // Orders & Fulfillment
  { path: "/admin/orders", exact: true, name: "Orders", component: OrderView },
  { path: "/admin/orders/:id", exact: true, name: "OrderDetails", component: AdminOrderDetails },
  { path: "/admin/invoice", exact: true, name: "ShowSales", component: InvoiceView },
  { path: "/admin/sales", exact: true, name: "ShowSales", component: InvoiceView },
  { path: "/admin/show-sales", exact: true, name: "ShowSales", component: InvoiceView },
  { path: "/admin/invoice-details/:order_id", exact: true, name: "InvoiceDetails", component: InvoiceDetails },

  // Inventory & Stock
  { path: "/admin/inventory", exact: true, name: "Inventory", component: AdminInventory },

  // Customers & Users
  { path: "/admin/customers", exact: true, name: "Customers", component: AdminCustomers },
  { path: "/admin/users", exact: true, name: "Users", component: UserView },

  // Marketing, Coupons & Discounts
  { path: "/admin/coupons", exact: true, name: "Coupons", component: AdminCoupons },
  { path: "/admin/discount", exact: true, name: "Discount", component: DiscountView },
  { path: "/admin/discounts", exact: true, name: "Discount", component: DiscountView },
  { path: "/admin/reviews", exact: true, name: "Reviews", component: AdminReviews },
  { path: "/admin/seo", exact: true, name: "SeoAudit", component: SeoAudit },
  { path: "/admin/seo/search-console", exact: true, name: "SearchConsole", component: SearchConsole },
  { path: "/admin/banners", exact: true, name: "Banners", component: () => <Redirect to="/admin/theme-editor" /> },

  // Reports & Analytics
  { path: "/admin/reports", exact: true, name: "Reports", component: AdminReports },
  { path: "/admin/analytics", exact: true, name: "Analytics", component: AdminReports },

  // Finance & Accounting
  { path: "/admin/chart_of_account", exact: true, name: "Money", component: MoneyOverview },
  { path: "/admin/couriers", exact: true, name: "Couriers", component: CourierSettings },
  { path: "/admin/payments", exact: true, name: "Payments", component: PaymentSettings },
  { path: "/admin/policies", exact: true, name: "Policies", component: PolicySettings },
  { path: "/admin/ledger", exact: true, name: "Ledger", component: Ledger },
  { path: "/admin/refundView", exact: true, name: "Refund", component: RefundViewMain },
  { path: "/admin/refund-order-details/:order_id", exact: true, name: "RefundOrderDetails", component: RefundOrderDetailsView },
  { path: "/admin/refund/sale-orders", exact: true, name: "RefundSaleOrders", component: SaleOrderView },
  { path: "/admin/refund/sale-orders-details/:order_id", exact: true, name: "RefundSaleOrdersDetails", component: SaleOrderDetailsView },

  // Support & Settings
  { path: "/admin/settings", exact: true, name: "Settings", component: AdminSettings },
  { path: "/admin/backup", exact: true, name: "StoreBackup", component: StoreBackup },
  { path: "/admin/profile", exact: true, name: "Profile", component: Profile },

  // Online Store Visual Theme Editor
  { path: "/admin/themes", exact: true, name: "Themes", component: ThemeLibrary },
  { path: "/admin/theme-editor", exact: true, name: "ThemeEditor", component: ThemeEditor },
];

export default routes;
